import React from "react";
import axios from "axios";
import { Modal } from "antd";
import { getTimeZone } from "../../../utils/shiftUtils";

const baseUrl = () => `${process.env.REACT_APP_BACKEND_URL}/shifts`;

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const shiftApi = {
  get: (path, params) => axios.get(`${baseUrl()}${path}`, { headers: authHeaders(), params }),
  // Every write carries the planner's timezone so the server reads wall-clock times correctly
  send: (method, path, body = {}) =>
    axios({
      method,
      url: `${baseUrl()}${path}`,
      data: { tz: getTimeZone(), ...body },
      headers: authHeaders()
    })
};

const confirmConflicts = (conflicts, t) =>
  new Promise(resolve =>
    Modal.confirm({
      title: t("Scheduling conflicts"),
      width: 600,
      content: (
        <div>
          <p>{t("These employees are on leave or already working at that time:")}</p>
          <ul style={{ maxHeight: 260, overflowY: "auto", paddingLeft: 18 }}>
            {conflicts.map((c, i) => (
              <li key={i}>
                <strong>{c.employeeName}</strong> · {c.date} · {c.shiftTitle}: {c.detail}
              </li>
            ))}
          </ul>
          {conflicts.length >= 50 && <p>{t("Only the first 50 conflicts are shown.")}</p>}
        </div>
      ),
      okText: t("Save anyway"),
      cancelText: t("Cancel"),
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  );

/**
 * Send a write; when the server reports conflicts (409), show them and resend with
 * `force` if the planner confirms. Resolves to the response, or null when cancelled.
 */
export const saveWithConflictCheck = async (method, path, body, t) => {
  try {
    return await shiftApi.send(method, path, body);
  } catch (err) {
    const conflicts = err?.response?.status === 409 && err.response.data?.conflicts;
    if (!conflicts) throw err;
    if (!(await confirmConflicts(conflicts, t))) return null;
    return shiftApi.send(method, path, { ...body, force: true });
  }
};
